import Enum from "../../../../../../enums/Enum";

const ScheduledForEnum = new Enum({
    Weekly: {name: "Weekly"},
    Monthly: {name: "Monthly"},
    Annually: {name: "Annually"}
});

export default ScheduledForEnum;